<script setup lang="ts">
defineProps<{
  hasActiveFilters?: string | boolean | Date | number | null;
}>();
</script>
<template>
  <div
    v-if="hasActiveFilters"
    class="mt-2 mb-2 p-2 bg-blue-50 border border-blue-200 rounded-md"
  >
    <div class="flex items-center gap-2 mb-2">
      <!-- Filter icon -->
      <svg
        class="h-4 w-4 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.707A1 1 0 013 7V4z"
        />
      </svg>
      <span class="text-sm font-medium text-blue-800">
        {{ $t("common.filter.appliedFilters") }}:</span
      >
    </div>

    <div class="flex flex-wrap gap-2">
      <slot name="filterTag"></slot>
    </div>
  </div>
</template>
